var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Wall-st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Wall-st0",
    d: "M20,15.9c-0.9,0-1.8,0.3-2.5,0.9L7.4,6.3C7.8,5.7,8.1,4.9,8.1,4c0-2.2-1.8-4-4-4S0,1.8,0,4s1.8,4,4,4 c1,0,2-0.4,2.7-1l10,10.4c-0.5,0.7-0.9,1.5-0.9,2.5c0,2.2,1.8,4,4,4s4-1.8,4-4S22.2,15.9,20,15.9z M4,7.1c-1.7,0-3-1.4-3-3 c0-1.7,1.4-3,3-3c1.7,0,3,1.4,3,3C7.1,5.7,5.7,7.1,4,7.1z M20,23c-1.7,0-3-1.4-3-3c0-1.7,1.4-3,3-3c1.7,0,3,1.4,3,3 C23,21.6,21.6,23,20,23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWall);
export default __webpack_public_path__ + "static/media/Wall.a3ea26a268870c01979a82bdaabdfab2.svg";
export { ForwardRef as ReactComponent };